import React from 'react';
import Cover from '../components/cover';
//import Ubicacion from '../components/Ubicacion';
import Tienda from '../components/tienda-home';
import EContact from '../components/contactanos';
//import ClientesDestacados from '../components/clientesdestacados';
import Seo from '../components/Seo';
import { DEFAULT_DESCRIPTION, SITE_NAME, absoluteUrl } from '../config/seo';
import '../styles/home.css';

const ORGANIZACION_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: absoluteUrl('/'),
  description: DEFAULT_DESCRIPTION,
  areaServed: 'Culiacán, Sinaloa',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+52-667-285-1980',
    contactType: 'sales',
    areaServed: 'MX',
    availableLanguage: 'Spanish',
  },
};

const Home = () => {
  return (
    <main className="home-main">
      <Seo path="/" description={DEFAULT_DESCRIPTION} jsonLd={ORGANIZACION_JSON_LD} />
      <div className="gradient-container">
        <div className="gradient-background" />
        <div className="gradient-content">
          <Cover />
          <Tienda />
          <EContact />
        </div>
      </div>
    </main>
  );
};

export default Home;
